import { render, staticRenderFns } from "./repair-add.vue?vue&type=template&id=10a98408&"
import script from "./repair-add.vue?vue&type=script&lang=js&"
export * from "./repair-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports